import { useEffect, useState } from "react";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

const initialForm = {
  code: "",
  pourcentage: 10,
  expiresAt: "",
};

export default function AdminCodePromo() {
  const [codes, setCodes] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCodes();
  }, []);

  const fetchCodes = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${apiUrl}/api/promos`);
      setCodes(res.data);
    } catch (err) {
      console.error("Erreur chargement codes promo :", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        code: form.code,
        pourcentage: form.pourcentage,
        expiresAt: form.expiresAt ? new Date(form.expiresAt) : null,
      };

      if (editingId) {
        await axios.put(`${apiUrl}/api/promos/${editingId}`, payload);
      } else {
        await axios.post(`${apiUrl}/api/promos`, payload);
      }

      setForm(initialForm);
      setEditingId(null);
      fetchCodes();
    } catch (err) {
      console.error("Erreur sauvegarde code promo :", err);
    }
  };

  const handleEdit = (code) => {
    setForm({
      code: code.code,
      pourcentage: code.pourcentage,
      expiresAt: code.expiresAt?.slice(0, 10) || "",
    });
    setEditingId(code._id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer ce code promo ?")) return;
    try {
      await axios.delete(`${apiUrl}/api/promos/${id}`);
      fetchCodes();
    } catch (err) {
      console.error("Erreur suppression code promo :", err);
    }
  };

  return (
    <div className="admin-code-promo">
      <style>
        {`
          .admin-code-promo {
            max-width: 800px;
            margin: 0 auto;
            padding: 2rem;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          }

          .admin-code-promo h2 {
            color: #2d3748;
            font-size: 1.75rem;
            font-weight: 600;
            margin-bottom: 1.5rem;
            padding-bottom: 0.5rem;
            border-bottom: 2px solid #e2e8f0;
          }

          .promo-form {
            background: #f8fafc;
            padding: 1.5rem;
            border-radius: 0.5rem;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
            margin-bottom: 2rem;
          }

          .form-group {
            margin-bottom: 1.25rem;
          }

          .form-group label {
            display: block;
            font-weight: 500;
            color: #4a5568;
            margin-bottom: 0.5rem;
          }

          .form-group input {
            width: 95%;
            padding: 0.5rem 0.65rem;  /* réduit */
            border: 1px solid #e2e8f0;
            border-radius: 0.375rem;
            font-size: 0.95rem;        /* légèrement plus petit */
            transition: border-color 0.2s;
          }


          .form-group input:focus {
            outline: none;
            border-color: #4299e1;
            box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
          }

          .form-actions {
            display: flex;
            justify-content: flex-end;
            gap: 0.75rem;
            margin-top: 1.5rem;
          }

          .btn {
            padding: 0.5rem 1rem;
            border-radius: 0.375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          }

          .btn-cancel {
            background-color: #e2e8f0;
            color: #4a5568;
          }

          .btn-cancel:hover {
            background-color: #cbd5e0;
          }

          .btn-submit {
            background-color: #4299e1;
            color: white;
          }

          .btn-submit:hover {
            background-color: #3182ce;
          }

          .promo-list {
            display: flex;
            flex-direction: column;
            gap: 0.75rem;
          }

          /* Spinner moderne et centré */
          .loading-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 3rem 0;
            min-height: 200px;
          }

          .modern-spinner {
            position: relative;
            width: 60px;
            height: 60px;
            margin-bottom: 1rem;
          }

          .spinner-ring {
            position: absolute;
            width: 100%;
            height: 100%;
            border: 3px solid transparent;
            border-radius: 50%;
            animation: spin 1.5s linear infinite;
          }

          .spinner-ring:nth-child(1) {
            border-top-color: #4299e1;
            animation-delay: 0s;
          }

          .spinner-ring:nth-child(2) {
            border-right-color: #38b2ac;
            animation-delay: 0.5s;
          }

          .spinner-ring:nth-child(3) {
            border-bottom-color: #ed8936;
            animation-delay: 1s;
          }

          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }

          .loading-text {
            color: #4a5568;
            font-size: 1rem;
            font-weight: 500;
            margin: 0;
            text-align: center;
          }

          .promo-card {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1rem;
            background: white;
            border: 1px solid #e2e8f0;
            border-radius: 0.375rem;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            transition: transform 0.2s, box-shadow 0.2s;
          }

          .promo-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          }

          .promo-info h3 {
            font-size: 1.125rem;
            font-weight: 600;
            color: #2d3748;
            margin-bottom: 0.25rem;
          }

          .promo-info p {
            font-size: 0.875rem;
            color: #718096;
          }

          .promo-actions {
            display: flex;
            gap: 1rem;
          }

          .action-btn {
            font-size: 0.875rem;
            font-weight: 500;
            cursor: pointer;
            background: none;
            border: none;
            padding: 0.25rem 0.5rem;
            border-radius: 0.25rem;
            transition: all 0.2s;
            margin-left: 1rem;
            margin-right: 1rem;
          }

          .edit-btn {
            color: #3182ce;
          }

          .edit-btn:hover {
            background-color: #ebf8ff;
          }

          .delete-btn {
            color: #e53e3e;
          }

          .delete-btn:hover {
            background-color: #fff5f5;
          }

          .loading-message,
          .empty-message {
            text-align: center;
            padding: 2rem;
            color: #718096;
            font-size: 1.125rem;
          }

          @media (max-width: 640px) {
            .admin-code-promo {
              padding: 1rem;
            }
            
            .promo-card {
              flex-direction: column;
              align-items: flex-start;
              gap: 1rem;
            }
            
            .promo-actions {
              width: 100%;
              justify-content: flex-end;
            }
          }
        `}
      </style>

      <h2>Gestion des codes promo</h2>

      <form onSubmit={handleSubmit} className="promo-form">
        <div className="form-group">
          <label>Code</label>
          <input
            type="text"
            value={form.code}
            onChange={(e) => setForm({ ...form, code: e.target.value })}
            required
          />
        </div>

        <div className="form-group">
          <label>Pourcentage (%)</label>
          <input
            type="number"
            min="1"
            max="100"
            value={form.pourcentage}
            onChange={(e) =>
              setForm({ ...form, pourcentage: Number(e.target.value) })
            }
            required
          />
        </div>

        <div className="form-group">
          <label>Date d'expiration</label>
          <input
            type="date"
            value={form.expiresAt}
            onChange={(e) => setForm({ ...form, expiresAt: e.target.value })}
            required
          />
        </div>

        <div className="form-actions">
          {editingId && (
            <button
              type="button"
              onClick={() => {
                setForm(initialForm);
                setEditingId(null);
              }}
              className="btn btn-cancel"
            >
              Annuler
            </button>
          )}
          <button type="submit" className="btn btn-submit">
            {editingId ? "Modifier" : "Ajouter"}
          </button>
        </div>
      </form>

      {loading ? (
        <div className="loading-container">
          <div className="modern-spinner">
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
          </div>
          <p className="loading-text">Chargement en cours...</p>
        </div>
      ) : (
        <div className="promo-list">
          {codes.length === 0 ? (
            <p className="empty-message">Aucun code promo pour le moment.</p>
          ) : (
            codes.map((c) => (
              <div key={c._id} className="promo-card">
                <div className="promo-info">
                  <h3>{c.code}</h3>
                  <p>
                    {c.pourcentage}% – expire le{" "}
                    {c.expiresAt
                      ? new Date(c.expiresAt).toLocaleDateString()
                      : "Sans limite"}
                  </p>
                </div>
                <div className="promo-actions">
                  <button
                    onClick={() => handleEdit(c)}
                    className="action-btn edit-btn"
                  >
                    Modifier
                  </button>
                  <button
                    onClick={() => handleDelete(c._id)}
                    className="action-btn delete-btn"
                  >
                    Supprimer
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
